import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, Form, Select, message, Button } from "antd";
import restaurantSchemaActions from "../../../redux/restaurantSchema/actions";
import CloseButton from "../../Common/CloseButton/CloseButton";

const { Option } = Select;
const { createNewReservationTable } = restaurantSchemaActions;

const CreateTableModal = ({
  openCreateTableModal,
  setOpenCreateTableModal,
  regionId,
}) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const { touchSaleTablesPerRegion } = useSelector(
    (state) => state.restaurantSchemaReducer
  );

  const handleAddTable = () => {
    form.validateFields().then((values) => {
      let [shape, chairsCount] = values.shape.split("-");

      const tableName = touchSaleTablesPerRegion.filter(
        (table) => table.id === values.originalTouchSaleTables
      )[0].name;

      dispatch(
        createNewReservationTable({
          tableName: tableName,
          touchSaleTableId: values.originalTouchSaleTables,
          regionId: regionId,
          x: 650,
          y: 325,
          direction: 0,
          shape: parseInt(shape),
          seatsCount: parseInt(chairsCount),
          organizationId: parseInt(localStorage.getItem("organizationId")),
        })
      );

      setOpenCreateTableModal(false);
      message.success("Успешно добавена маса");
      form.resetFields();
    });
  };

  const shape = [
    { name: "Кръгла маса + 2 стола", value: "1-2" },
    { name: "Кръгла маса + 4 стола", value: "1-4" },
    { name: "Кръгла маса + 8 стола", value: "1-8" },
    { name: "Квардатна маса + 1 стол", value: "2-1" },
    { name: "Квардатна маса + 2 стол", value: "2-2" },
    { name: "Квардатна маса + 3 стол", value: "2-3" },
    { name: "Квардатна маса + 4 стол", value: "2-4" },
    {
      name: "Правоъгълна маса + 6 стола",
      value: "3-6",
    },
    {
      name: "Правоъгълна маса + 8 стола",
      value: "3-8",
    },
    {
      name: "Правоъгълна маса + 10 стола",
      value: "3-10",
    },
  ];

  return (
    <Modal
      closeIcon={<CloseButton />}
      title="Добави Маса"
      open={openCreateTableModal}
      onOk={handleAddTable}
      onCancel={() => setOpenCreateTableModal(false)}
      footer={null}
      className="restaurant-scheme-table-modal"
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="originalTouchSaleTables"
          label="Номер на масата"
          rules={[{ required: true, message: "Моля изберете име на масата." }]}
        >
          <Select
            showSearch
            virtual={false}
            placeholder="Маса"
            placement="topLeft"
            className="restaurant-scheme-table-modal-select ant-select-selection-search-input"
          >
            {touchSaleTablesPerRegion.map((table, index) => (
              <Option
                key={`${table.id}-${index}`}
                value={table.id}
                className="restaurant-scheme-table-modal-option"
              >
                {table.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="shape"
          label="Форма на масата"
          rules={[
            { required: true, message: "Моля изберете форма на масата." },
          ]}
        >
          <Select
            showSearch
            virtual={false}
            placeholder="Форма на масата"
            placement="topLeft"
            className="restaurant-scheme-table-modal-select ant-select-selection-search-input"
          >
            {shape.map((singleShape, index) => (
              <Option
                key={`${singleShape.value}-${index}`}
                value={singleShape.value}
                className="restaurant-scheme-table-modal-option"
              >
                {singleShape.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
      <div className="restaurant-scheme-edit-table-modal-footer">
        <Button type="primary" onClick={handleAddTable}>
          Добави Маса
        </Button>
      </div>
    </Modal>
  );
};

export default CreateTableModal;
